import React from 'react';
import ChatGpt from "../../../assets/images/chatgpt_logo.png"
import TlkLogo from "../../../assets/images/tlklogos.svg"
// import InfoIcon from '@mui/icons-material/Info';

function Footer({botInfo,prefLang,setOpenInfoModal}) {
    return(
        <div className="chat-footer-wrapper">
            {
                botInfo?.data?.mobileAppConfig?.footerCraft ?
                    <>
                        {botInfo?.data?.mobileAppConfig?.footerCraft ? botInfo?.data?.mobileAppConfig?.footerCraft?.[prefLang] : "crafted by"} &nbsp;<div className="company-text">
                            <img className="tlk-logo-ftr" src={TlkLogo} alt="talkk.ai" />
                        </div>
                        {/* {botInfo?.data?.mobileAppConfig?.footerUse ? botInfo?.data?.mobileAppConfig?.footerUse?.[prefLang] : "using"} <b>&nbsp;GPT</b>
                        <img className='chatgpt-logo' src={ChatGpt} /> */}
                    </>
                :   
                    <>
                        {botInfo?.data?.mobileAppConfig?.poweredByText ? botInfo?.data?.mobileAppConfig?.poweredByText?.[prefLang] : "Powered by"} <div className="company-text">
                            &nbsp;<img className="tlk-logo-ftr" src={TlkLogo} alt="talkk.ai" />
                        </div>
                    </>
            }
            
        </div>
    )
}
export default Footer;
